import formData from './formData';

const {
  formField: {
    firstName,
    middleName,
    lastName,
    mmcId,
    dateOfBirth,
    gender,
    rating,
    type,
    agentUnion,
    status,
    twicTsaNum,
    frequentFlyerNumber,
    phone,
    email,
    placeOfBirth,
    seniority,
  },
} = formData;

const initialValues = {
  [firstName.name]: "",
  [middleName.name]: "",
  [lastName.name]: "",
  [mmcId.name]: "",
  [dateOfBirth.name]: "",
  [gender.name]: undefined,
  [rating.name]: undefined,
  [type.name]: "",
  [agentUnion.name]: "",
  [status.name]: undefined,
  [twicTsaNum.name]: "",
  [frequentFlyerNumber.name]: "",
  [phone.name]: "",
  [email.name]: "",
  [placeOfBirth.name]: "",
  [seniority.name]: null,
};

export default initialValues;
